import { computeLogReturns, rollingStdev, rollingSum, costOfLoss, logToPercentReturns } from "../../utils/math";
import {isUUID} from "../../utils/strings";

export const prepareHistoricalPerformance = (items)=>{
  let rows = [];
  items.forEach(x=>{
    rows.push([
      x.label,
      x?.total?.ytd || 0,
      x?.['252']?.pct_r,  // 1 Year
      x?.['756']?.pct_r,
      x?.['1260']?.pct_r, // 3 Year
    ]);
  });
  return rows;
}


export const prepareBestWorstData = (items, window)=>{
  let rows = [];
  const key = window || '252';
  items.forEach(x=>{
    const worst = x?.[key]?.best_worst?.min?.val
    rows.push({
      label: x.label,
      best: x?.[key]?.best_worst?.max?.val,  // 1 Year
      worst: worst,
      backToEven: worst < 0 ? costOfLoss(worst*0.01) : 0,
      beta: x?.[key]?.beta || 0,
      sharpe: x?.[key]?.sharpe || 0
    })
  });
  return rows;
}


export const prepareHistoricalVolatilityData = (items, itemColors, windowSize) => {
    let volatilitySeries = [];
    let amplifiedSeries = [];
    let rollingVolatilitySeries = [];
    items.forEach(item => {
        let dates = item.chart.map(x=>x[0]);
        let values = item.chart.map(x=>x[1]);
        let logReturns = computeLogReturns(values);
        let volatilities = rollingStdev(values, windowSize);
        let percentReturns = logToPercentReturns(logReturns.slice(windowSize - 1, ));
        volatilitySeries.push({
            name: `${item.label} Volatility`,
            type: 'line',
            data: volatilities.map((vol, index) => ([
                dates[index + windowSize - 1],
                values[index + windowSize - 1],
            ])),
            stroke: itemColors[item.id],
            fill: itemColors[item.id],
        });
        // volatilitySeries.push({
        //     name: `${item.label} Volatility`,
        //     type: 'rangeSplineArea',
        //     data: volatilities.map((vol, index) => ([
        //         dates[index + windowSize - 1],
        //         ((percentReturns[index] - (percentReturns[index] * vol))*2)*100,
        //         ((percentReturns[index] + (percentReturns[index] * vol))*2)*100
        //     ])),
        //     stroke: itemColors[item.id],
        //     fill: itemColors[item.id],
        //     valueKey: 'low',
        //     extraFields: ['high'],
        // });
        rollingVolatilitySeries.push({
            name: `${item.label} Rolling Volatility`,
            type: 'line',
            data: volatilities.map((vol, index) => ([
                dates[index + windowSize - 1], vol*100
            ])),
            stroke: itemColors[item.id],
        });
        amplifiedSeries.push({
            name: `${item.label} Amplified`,
            type: 'line',
            data: percentReturns.map((ret, index) => ([
                dates[index + windowSize - 1], (ret * volatilities[index])*100
            ])),
            stroke: itemColors[item.id],
        });
    });
    return {volatilitySeries, amplifiedSeries, rollingVolatilitySeries}
};

export const prepareOverviewChartData = (items, itemColors)=>{
  let chartSeries = [];
  items.forEach((item, index) => {
    let data = item.chart;
    let formattedData = [];
    for (let i = 0; i < data.length; i++) {
      formattedData.push(data[i]);
    }
    chartSeries.push({
      name: item.label,
      type: 'line',
      data: formattedData,
      stroke: itemColors[item.symbol || item.id],
      precision: 2,
      format: '%',
      thickness:  isUUID(item.id||item.symbol) ? 3 : 1
    });
  });
  return [
      {
          plot: 0,
          data: chartSeries,
          yScale: 'percent',
          format: '%',
          legend: {postfix: '%', precision: 2, format: '%'}
      }];
}




export const prepareCalendarReturns = (items, itemColors)=>{
  let data = [];
  let colors = {};
  let years = Object.keys(items[0].calendar);
    years.forEach(year=>{
      let obj = {
        id: year
      };
      items.forEach(item=>{
        obj[item.label] = parseFloat((item.calendar[year] * 100).toFixed(1));
        if (!colors.hasOwnProperty(item.label)){
            colors[item.label] = itemColors[item.id];
        }
      });
      data.push(obj);

  });
  return {data, keys: items.map(x=>x.label), customColors: colors};
}


export const prepareCalendarReturnsForSwarm = (items, itemColors) => {
  const data = [];
  const uniqueGroups = new Set(); // To track unique groups for coloring

  // Loop through each year and each item to create the data points
  items.forEach(item => {
    Object.keys(item.calendar).forEach(year => {
      const id = `${item.label}-${year}`; // Creating a unique ID
      const value = parseFloat((item.calendar[year] * 100).toFixed(1)); // Format the value
      const group = year; // Using the label as the group
      const size = 1;

      // Push each item-year combination as a separate data point
      data.push({ id, group, value, size });

      // Collect unique groups for possible color mapping
      uniqueGroups.add(group);
    });
  });

  // Optionally prepare a color mapping if custom colors are provided
  const colorMapping = {};
  if (itemColors) {
    uniqueGroups.forEach(group => {
      if (itemColors[group]) {
        colorMapping[group] = itemColors[group];
      }
    });
  }

  return { data, groups: Array.from(uniqueGroups), customColors: colorMapping };
};



export const prepareCalendarReturnsForCallan = (items) => {
  let chartData = [];
  let years = Object.keys(items[0].calendar);

  years.forEach(year => {
    // Create an array of name-value pairs for the current year
    let yearData = items.map(item => ({
      id: item.id,
      name: item.label,
      value: item.calendar[year],
    }));

    // Sort the array based on value in descending order
    yearData.sort((a, b) => b.value - a.value);

    // Add the sorted data to the chartData array
    chartData.push({
      year,
      data: yearData,
    });
  });

  return chartData;
};
